import memberType from '../../core/memberType';

/**
 * Default structure for members
 */
const defaultMember = {
  id: '',
  firstName: '',
  lastName: '',
  email: '',
  address: '',
  phone: '',
  phoneIsMobile: false,
  tobacco: undefined,
  type: memberType.primary,
  gender: '', // m || f
  dob: '', // MM/dd/yyyy
  age: 0,
  height: {
    feet: '',
    inches: '',
  },
  weight: '',
};

export default defaultMember;
